import { jsx, jsxs } from "react/jsx-runtime";
import { isDefined } from "@eih-netbroker/common";
import { useMemo } from "react";
const classNames = (...names)=>names.filter(Boolean).join(' ');
var nbButtonLoaderStyles = {
    overlay: 'NbButtonLoader_overlay__18ri54d0',
    container: 'NbButtonLoader_container__18ri54d6',
    dot1: 'NbButtonLoader_dot1__18ri54d9 NbButtonLoader_dotBase__18ri54d8',
    dot2: 'NbButtonLoader_dot2__18ri54da NbButtonLoader_dotBase__18ri54d8',
    dot3: 'NbButtonLoader_dot3__18ri54db NbButtonLoader_dotBase__18ri54d8',
    containerSizes: {
        xs: 'NbButtonLoader_containerSizes_xs__18ri54d1',
        s: 'NbButtonLoader_containerSizes_s__18ri54d2',
        m: 'NbButtonLoader_containerSizes_m__18ri54d3',
        l: 'NbButtonLoader_containerSizes_l__18ri54d4',
        xl: 'NbButtonLoader_containerSizes_xl__18ri54d5'
    }
};
const NbButtonLoader = ({ size })=>{
    const className = classNames(nbButtonLoaderStyles.container, nbButtonLoaderStyles.containerSizes[size]);
    return /*#__PURE__*/ jsx("span", {
        className: nbButtonLoaderStyles.overlay,
        children: /*#__PURE__*/ jsxs("span", {
            className: className,
            children: [
                /*#__PURE__*/ jsx("span", {
                    className: nbButtonLoaderStyles.dot1
                }),
                /*#__PURE__*/ jsx("span", {
                    className: nbButtonLoaderStyles.dot2
                }),
                /*#__PURE__*/ jsx("span", {
                    className: nbButtonLoaderStyles.dot3
                })
            ]
        })
    });
};
var nbButtonStyles = {
    buttonBase: 'NbButton_buttonBase__n3up5n0',
    buttonFullWidth: 'NbButton_buttonFullWidth__n3up5n1',
    buttonTextBase: 'NbButton_buttonTextBase__n3up5n2',
    buttonVariantColors: {
        primary: 'NbButton_createButtonThemeStyle__n3up5n3',
        light: 'NbButton_createButtonThemeStyle__n3up5n4',
        orange: 'NbButton_createButtonThemeStyle__n3up5n5',
        outline: 'NbButton_createButtonThemeStyle__n3up5n6',
        ghost: 'NbButton_createButtonThemeStyle__n3up5n7',
        red: 'NbButton_createButtonThemeStyle__n3up5n8',
        white: 'NbButton_createButtonThemeStyle__n3up5n9'
    },
    buttonDimensions: {
        xs: 'NbButton_buttonDimensions_xs__n3up5na',
        s: 'NbButton_buttonDimensions_s__n3up5nb',
        m: 'NbButton_buttonDimensions_m__n3up5nc',
        l: 'NbButton_buttonDimensions_l__n3up5nd',
        xl: 'NbButton_buttonDimensions_xl__n3up5ne'
    },
    buttonTextDimensions: {
        xs: 'typography_TypographyStyles_miniNormalSemiBold__mjxjqv1b',
        s: 'typography_TypographyStyles_smallSemiBold__mjxjqv16',
        m: 'typography_TypographyStyles_paragraphSemiBold__mjxjqv11',
        l: 'typography_TypographyStyles_hero6SemiBold__mjxjqvw',
        xl: 'typography_TypographyStyles_hero6SemiBold__mjxjqvw'
    },
    buttonContentDimensions: {
        xs: 'NbButton_buttonContentDimensions_xs__n3up5nf',
        s: 'NbButton_buttonContentDimensions_s__n3up5ng',
        m: 'NbButton_buttonContentDimensions_m__n3up5nh',
        l: 'NbButton_buttonContentDimensions_l__n3up5ni',
        xl: 'NbButton_buttonContentDimensions_xl__n3up5nj'
    },
    buttonHiddenContent: 'NbButton_buttonHiddenContent__n3up5nk'
};
const useButtonClassNames = ({ size, variant, classes, isLoading, isFullWidth })=>{
    const buttonClassName = classNames(nbButtonStyles.buttonBase, nbButtonStyles.buttonVariantColors[variant], nbButtonStyles.buttonDimensions[size], isFullWidth ? nbButtonStyles.buttonFullWidth : void 0, classes?.button);
    const textClassName = classNames(nbButtonStyles.buttonTextBase, nbButtonStyles.buttonTextDimensions[size], classes?.text);
    const contentClassName = classNames(nbButtonStyles.buttonContentDimensions[size], isLoading ? nbButtonStyles.buttonHiddenContent : void 0);
    return {
        buttonClassName,
        textClassName,
        contentClassName
    };
};
const NbButton = ({ type, children, startAddon, endAddon, ref, disabled, isLoading, size, variant, classes, isFullWidth, onClick, ...dataAttributes })=>{
    const computedClassNames = useButtonClassNames({
        size,
        variant,
        classes,
        isFullWidth,
        isLoading
    });
    return /*#__PURE__*/ jsxs("button", {
        ...dataAttributes,
        type: type,
        className: computedClassNames.buttonClassName,
        disabled: disabled,
        onClick: isLoading ? void 0 : onClick,
        ref: ref,
        children: [
            /*#__PURE__*/ jsxs("span", {
                className: computedClassNames.contentClassName,
                children: [
                    startAddon,
                    /*#__PURE__*/ jsx("span", {
                        className: computedClassNames.textClassName,
                        children: children
                    }),
                    endAddon
                ]
            }),
            isLoading && /*#__PURE__*/ jsx(NbButtonLoader, {
                size: size
            })
        ]
    });
};
const handleLoadingClick = (e)=>e.preventDefault();
const NbLinkButton = ({ children, startAddon, endAddon, href, ref, target, rel, isLoading, size, variant, classes, isFullWidth, ...dataAttributes })=>{
    const computedClassNames = useButtonClassNames({
        classes,
        isFullWidth,
        isLoading,
        size,
        variant
    });
    return /*#__PURE__*/ jsxs("a", {
        ...dataAttributes,
        className: computedClassNames.buttonClassName,
        onClick: isLoading ? handleLoadingClick : void 0,
        ref: ref,
        href: href,
        rel: rel,
        target: target,
        children: [
            /*#__PURE__*/ jsxs("span", {
                className: computedClassNames.contentClassName,
                children: [
                    startAddon,
                    /*#__PURE__*/ jsx("span", {
                        className: computedClassNames.textClassName,
                        children: children
                    }),
                    endAddon
                ]
            }),
            isLoading && /*#__PURE__*/ jsx(NbButtonLoader, {
                size: size
            })
        ]
    });
};
var iconAutoSize = 'NbIcon_iconAutoSize__18z9hxj5';
var iconSizes = {
    small: 'NbIcon_iconSizes_small__18z9hxj2',
    medium: 'NbIcon_iconSizes_medium__18z9hxj3',
    large: 'NbIcon_iconSizes_large__18z9hxj4'
};
var baseIconStyle = 'NbIcon_baseIconStyle__18z9hxj1';
const NbIcon = ({ svg: SvgComponent, color, size })=>{
    const className = classNames(baseIconStyle, isDefined(size) ? iconSizes[size] : iconAutoSize);
    const style = useMemo(()=>color ? {
            color: color
        } : void 0, [
        color
    ]);
    return /*#__PURE__*/ jsx(SvgComponent, {
        style: style,
        className: className
    });
};
var textStyles = {
    primary: 'NbText_textStyles_primary__111qjfv0',
    secondary: 'NbText_textStyles_secondary__111qjfv1'
};
var TypographyStyles = {
    displayRegular: 'typography_TypographyStyles_displayRegular__mjxjqv0',
    displayMedium: 'typography_TypographyStyles_displayMedium__mjxjqv1',
    displaySemiBold: 'typography_TypographyStyles_displaySemiBold__mjxjqv2',
    displayBold: 'typography_TypographyStyles_displayBold__mjxjqv3',
    displayExtraBold: 'typography_TypographyStyles_displayExtraBold__mjxjqv4',
    hero1Regular: 'typography_TypographyStyles_hero1Regular__mjxjqv5',
    hero1Medium: 'typography_TypographyStyles_hero1Medium__mjxjqv6',
    hero1SemiBold: 'typography_TypographyStyles_hero1SemiBold__mjxjqv7',
    hero1Bold: 'typography_TypographyStyles_hero1Bold__mjxjqv8',
    hero1ExtraBold: 'typography_TypographyStyles_hero1ExtraBold__mjxjqv9',
    hero2Regular: 'typography_TypographyStyles_hero2Regular__mjxjqva',
    hero2Medium: 'typography_TypographyStyles_hero2Medium__mjxjqvb',
    hero2SemiBold: 'typography_TypographyStyles_hero2SemiBold__mjxjqvc',
    hero2Bold: 'typography_TypographyStyles_hero2Bold__mjxjqvd',
    hero2ExtraBold: 'typography_TypographyStyles_hero2ExtraBold__mjxjqve',
    hero3Regular: 'typography_TypographyStyles_hero3Regular__mjxjqvf',
    hero3Medium: 'typography_TypographyStyles_hero3Medium__mjxjqvg',
    hero3SemiBold: 'typography_TypographyStyles_hero3SemiBold__mjxjqvh',
    hero3Bold: 'typography_TypographyStyles_hero3Bold__mjxjqvi',
    hero3ExtraBold: 'typography_TypographyStyles_hero3ExtraBold__mjxjqvj',
    hero4Regular: 'typography_TypographyStyles_hero4Regular__mjxjqvk',
    hero4Medium: 'typography_TypographyStyles_hero4Medium__mjxjqvl',
    hero4SemiBold: 'typography_TypographyStyles_hero4SemiBold__mjxjqvm',
    hero4Bold: 'typography_TypographyStyles_hero4Bold__mjxjqvn',
    hero4ExtraBold: 'typography_TypographyStyles_hero4ExtraBold__mjxjqvo',
    hero5Regular: 'typography_TypographyStyles_hero5Regular__mjxjqvp',
    hero5Medium: 'typography_TypographyStyles_hero5Medium__mjxjqvq',
    hero5SemiBold: 'typography_TypographyStyles_hero5SemiBold__mjxjqvr',
    hero5Bold: 'typography_TypographyStyles_hero5Bold__mjxjqvs',
    hero5ExtraBold: 'typography_TypographyStyles_hero5ExtraBold__mjxjqvt',
    hero6Regular: 'typography_TypographyStyles_hero6Regular__mjxjqvu',
    hero6Medium: 'typography_TypographyStyles_hero6Medium__mjxjqvv',
    hero6SemiBold: 'typography_TypographyStyles_hero6SemiBold__mjxjqvw',
    hero6Bold: 'typography_TypographyStyles_hero6Bold__mjxjqvx',
    hero6ExtraBold: 'typography_TypographyStyles_hero6ExtraBold__mjxjqvy',
    paragraphRegular: 'typography_TypographyStyles_paragraphRegular__mjxjqvz',
    paragraphMedium: 'typography_TypographyStyles_paragraphMedium__mjxjqv10',
    paragraphSemiBold: 'typography_TypographyStyles_paragraphSemiBold__mjxjqv11',
    paragraphBold: 'typography_TypographyStyles_paragraphBold__mjxjqv12',
    paragraphExtraBold: 'typography_TypographyStyles_paragraphExtraBold__mjxjqv13',
    smallRegular: 'typography_TypographyStyles_smallRegular__mjxjqv14',
    smallMedium: 'typography_TypographyStyles_smallMedium__mjxjqv15',
    smallSemiBold: 'typography_TypographyStyles_smallSemiBold__mjxjqv16',
    smallBold: 'typography_TypographyStyles_smallBold__mjxjqv17',
    smallExtraBold: 'typography_TypographyStyles_smallExtraBold__mjxjqv18',
    miniNormalRegular: 'typography_TypographyStyles_miniNormalRegular__mjxjqv19',
    miniNormalMedium: 'typography_TypographyStyles_miniNormalMedium__mjxjqv1a',
    miniNormalSemiBold: 'typography_TypographyStyles_miniNormalSemiBold__mjxjqv1b',
    miniNormalBold: 'typography_TypographyStyles_miniNormalBold__mjxjqv1c',
    miniNormalExtraBold: 'typography_TypographyStyles_miniNormalExtraBold__mjxjqv1d',
    miniWideSpacingMedium: 'typography_TypographyStyles_miniWideSpacingMedium__mjxjqv1e',
    miniWideSpacingSemiBold: 'typography_TypographyStyles_miniWideSpacingSemiBold__mjxjqv1f',
    miniWideSpacingBold: 'typography_TypographyStyles_miniWideSpacingBold__mjxjqv1g',
    tinyRegular: 'typography_TypographyStyles_tinyRegular__mjxjqv1h',
    tinyMedium: 'typography_TypographyStyles_tinyMedium__mjxjqv1i',
    tinySemiBold: 'typography_TypographyStyles_tinySemiBold__mjxjqv1j',
    tinyBold: 'typography_TypographyStyles_tinyBold__mjxjqv1k',
    tinyExtraBold: 'typography_TypographyStyles_tinyExtraBold__mjxjqv1l'
};
const NbText = ({ typography, variant, children })=>{
    const className = classNames(isDefined(typography) ? TypographyStyles[typography] : void 0, isDefined(variant) ? textStyles[variant] : void 0);
    return /*#__PURE__*/ jsx("span", {
        className: className,
        children: children
    });
};
var scrollbarClass = 'scrollBar_scrollbarClass__1rt2ub70';
var darkColors = {
    designSystem: {
        button: {
            variants: {
                primary: {
                    normal: {
                        background: '#2870ED',
                        text: '#FFFFFF'
                    },
                    hover: {
                        background: '#538DF1',
                        text: '#FFFFFF'
                    },
                    pressed: {
                        background: '#205ABE',
                        text: '#FFFFFF'
                    },
                    disabled: {
                        background: '#2A2C32',
                        text: '#5B616E'
                    }
                },
                orange: {
                    normal: {
                        background: '#CC6100',
                        text: '#FFFFFF'
                    },
                    hover: {
                        background: '#FF7900',
                        text: '#FFFFFF'
                    },
                    pressed: {
                        background: '#663000',
                        text: '#FFFFFF'
                    },
                    disabled: {
                        background: '#2A2C32',
                        text: '#6B7280'
                    }
                },
                ghost: {
                    normal: {
                        background: '#00000000',
                        text: '#538DF1'
                    },
                    hover: {
                        background: '#2870ED1A',
                        text: '#2870ED'
                    },
                    pressed: {
                        background: '#2870ED1A',
                        text: '#205ABE'
                    },
                    disabled: {
                        background: '#00000000',
                        text: '#5B616E'
                    }
                },
                red: {
                    normal: {
                        background: '#E72222',
                        text: '#FFFFFF'
                    },
                    hover: {
                        background: '#EC4E4E',
                        text: '#FFFFFF'
                    },
                    pressed: {
                        background: '#5C0E0E',
                        text: '#FFFFFF'
                    },
                    disabled: {
                        background: '#2A2C32',
                        text: '#6B7280'
                    }
                },
                white: {
                    normal: {
                        background: '#191B1F',
                        text: '#538DF1'
                    },
                    hover: {
                        background: '#2A2C32',
                        text: '#2870ED'
                    },
                    pressed: {
                        background: '#2A2C32',
                        text: '#205ABE'
                    },
                    disabled: {
                        background: '#2A2C32',
                        text: '#5B616E'
                    }
                },
                light: {
                    normal: {
                        background: '#2A2C32',
                        text: '#538DF1'
                    },
                    hover: {
                        background: '#2A2C32',
                        text: '#2870ED'
                    },
                    pressed: {
                        background: '#2A2C32',
                        text: '#205ABE'
                    },
                    disabled: {
                        background: '#2A2C32',
                        text: '#5B616E'
                    }
                },
                outline: {
                    normal: {
                        background: '#00000000',
                        text: '#538DF1',
                        border: '#538DF1'
                    },
                    hover: {
                        background: '#2870ED1A',
                        text: '#2870ED',
                        border: '#2870ED'
                    },
                    pressed: {
                        background: '#2870ED1A',
                        text: '#205ABE',
                        border: '#205ABE'
                    },
                    disabled: {
                        background: '#00000000',
                        text: '#5B616E',
                        border: '#2A2C32'
                    }
                }
            }
        },
        text: {
            primary: '#FFFFFF',
            secondary: '#B6BAC3'
        }
    },
    __storybook: {
        background: '#000000'
    }
};
var darkThemeClass = 'theme_darkThemeClass__kvcbpf1s';
var lightColors = {
    designSystem: {
        button: {
            variants: {
                primary: {
                    normal: {
                        background: '#2870ED',
                        text: '#FFFFFF'
                    },
                    hover: {
                        background: '#538DF1',
                        text: '#FFFFFF'
                    },
                    pressed: {
                        background: '#205ABE',
                        text: '#FFFFFF'
                    },
                    disabled: {
                        background: '#EDEEF1',
                        text: '#B6BAC3'
                    }
                },
                orange: {
                    normal: {
                        background: '#FF7900',
                        text: '#FFFFFF'
                    },
                    hover: {
                        background: '#FF9433',
                        text: '#FFFFFF'
                    },
                    pressed: {
                        background: '#CC6100',
                        text: '#FFFFFF'
                    },
                    disabled: {
                        background: '#EDEEF1',
                        text: '#B6BAC3'
                    }
                },
                ghost: {
                    normal: {
                        background: '#FFFFFF00',
                        text: '#2870ED'
                    },
                    hover: {
                        background: '#EEF4FE',
                        text: '#538DF1'
                    },
                    pressed: {
                        background: '#EEF4FE',
                        text: '#205ABE'
                    },
                    disabled: {
                        background: '#FFFFFF00',
                        text: '#B6BAC3'
                    }
                },
                red: {
                    normal: {
                        background: '#E72222',
                        text: '#FFFFFF'
                    },
                    hover: {
                        background: '#EC4E4E',
                        text: '#FFFFFF'
                    },
                    pressed: {
                        background: '#B91B1B',
                        text: '#FFFFFF'
                    },
                    disabled: {
                        background: '#EDEEF1',
                        text: '#B6BAC3'
                    }
                },
                white: {
                    normal: {
                        background: '#FFFFFF',
                        text: '#2870ED'
                    },
                    hover: {
                        background: '#EEF4FE',
                        text: '#538DF1'
                    },
                    pressed: {
                        background: '#EEF4FE',
                        text: '#205ABE'
                    },
                    disabled: {
                        background: '#EDEEF1',
                        text: '#B6BAC3'
                    }
                },
                light: {
                    normal: {
                        background: '#EEF4FE',
                        text: '#2870ED'
                    },
                    hover: {
                        background: '#EEF4FE',
                        text: '#538DF1'
                    },
                    pressed: {
                        background: '#EEF4FE',
                        text: '#205ABE'
                    },
                    disabled: {
                        background: '#EDEEF1',
                        text: '#B6BAC3'
                    }
                },
                outline: {
                    normal: {
                        background: '#FFFFFF00',
                        text: '#2870ED',
                        border: '#2870ED'
                    },
                    hover: {
                        background: '#EEF4FE',
                        text: '#538DF1',
                        border: '#538DF1'
                    },
                    pressed: {
                        background: '#EEF4FE',
                        text: '#205ABE',
                        border: '#205ABE'
                    },
                    disabled: {
                        background: '#EDEEF1',
                        text: '#B6BAC3',
                        border: '#B6BAC3'
                    }
                }
            }
        },
        text: {
            primary: '#102D5F',
            secondary: '#506891'
        }
    },
    __storybook: {
        background: '#EDEEF1'
    }
};
var lightThemeClass = 'theme_lightThemeClass__kvcbpf0';
var theme = {
    designSystem: {
        button: {
            variants: {
                primary: {
                    normal: {
                        background: 'var(--designSystem-button-variants-primary-normal-background__kvcbpf1)',
                        text: 'var(--designSystem-button-variants-primary-normal-text__kvcbpf2)'
                    },
                    hover: {
                        background: 'var(--designSystem-button-variants-primary-hover-background__kvcbpf3)',
                        text: 'var(--designSystem-button-variants-primary-hover-text__kvcbpf4)'
                    },
                    pressed: {
                        background: 'var(--designSystem-button-variants-primary-pressed-background__kvcbpf5)',
                        text: 'var(--designSystem-button-variants-primary-pressed-text__kvcbpf6)'
                    },
                    disabled: {
                        background: 'var(--designSystem-button-variants-primary-disabled-background__kvcbpf7)',
                        text: 'var(--designSystem-button-variants-primary-disabled-text__kvcbpf8)'
                    }
                },
                orange: {
                    normal: {
                        background: 'var(--designSystem-button-variants-orange-normal-background__kvcbpf9)',
                        text: 'var(--designSystem-button-variants-orange-normal-text__kvcbpfa)'
                    },
                    hover: {
                        background: 'var(--designSystem-button-variants-orange-hover-background__kvcbpfb)',
                        text: 'var(--designSystem-button-variants-orange-hover-text__kvcbpfc)'
                    },
                    pressed: {
                        background: 'var(--designSystem-button-variants-orange-pressed-background__kvcbpfd)',
                        text: 'var(--designSystem-button-variants-orange-pressed-text__kvcbpfe)'
                    },
                    disabled: {
                        background: 'var(--designSystem-button-variants-orange-disabled-background__kvcbpff)',
                        text: 'var(--designSystem-button-variants-orange-disabled-text__kvcbpfg)'
                    }
                },
                ghost: {
                    normal: {
                        background: 'var(--designSystem-button-variants-ghost-normal-background__kvcbpfh)',
                        text: 'var(--designSystem-button-variants-ghost-normal-text__kvcbpfi)'
                    },
                    hover: {
                        background: 'var(--designSystem-button-variants-ghost-hover-background__kvcbpfj)',
                        text: 'var(--designSystem-button-variants-ghost-hover-text__kvcbpfk)'
                    },
                    pressed: {
                        background: 'var(--designSystem-button-variants-ghost-pressed-background__kvcbpfl)',
                        text: 'var(--designSystem-button-variants-ghost-pressed-text__kvcbpfm)'
                    },
                    disabled: {
                        background: 'var(--designSystem-button-variants-ghost-disabled-background__kvcbpfn)',
                        text: 'var(--designSystem-button-variants-ghost-disabled-text__kvcbpfo)'
                    }
                },
                red: {
                    normal: {
                        background: 'var(--designSystem-button-variants-red-normal-background__kvcbpfp)',
                        text: 'var(--designSystem-button-variants-red-normal-text__kvcbpfq)'
                    },
                    hover: {
                        background: 'var(--designSystem-button-variants-red-hover-background__kvcbpfr)',
                        text: 'var(--designSystem-button-variants-red-hover-text__kvcbpfs)'
                    },
                    pressed: {
                        background: 'var(--designSystem-button-variants-red-pressed-background__kvcbpft)',
                        text: 'var(--designSystem-button-variants-red-pressed-text__kvcbpfu)'
                    },
                    disabled: {
                        background: 'var(--designSystem-button-variants-red-disabled-background__kvcbpfv)',
                        text: 'var(--designSystem-button-variants-red-disabled-text__kvcbpfw)'
                    }
                },
                white: {
                    normal: {
                        background: 'var(--designSystem-button-variants-white-normal-background__kvcbpfx)',
                        text: 'var(--designSystem-button-variants-white-normal-text__kvcbpfy)'
                    },
                    hover: {
                        background: 'var(--designSystem-button-variants-white-hover-background__kvcbpfz)',
                        text: 'var(--designSystem-button-variants-white-hover-text__kvcbpf10)'
                    },
                    pressed: {
                        background: 'var(--designSystem-button-variants-white-pressed-background__kvcbpf11)',
                        text: 'var(--designSystem-button-variants-white-pressed-text__kvcbpf12)'
                    },
                    disabled: {
                        background: 'var(--designSystem-button-variants-white-disabled-background__kvcbpf13)',
                        text: 'var(--designSystem-button-variants-white-disabled-text__kvcbpf14)'
                    }
                },
                light: {
                    normal: {
                        background: 'var(--designSystem-button-variants-light-normal-background__kvcbpf15)',
                        text: 'var(--designSystem-button-variants-light-normal-text__kvcbpf16)'
                    },
                    hover: {
                        background: 'var(--designSystem-button-variants-light-hover-background__kvcbpf17)',
                        text: 'var(--designSystem-button-variants-light-hover-text__kvcbpf18)'
                    },
                    pressed: {
                        background: 'var(--designSystem-button-variants-light-pressed-background__kvcbpf19)',
                        text: 'var(--designSystem-button-variants-light-pressed-text__kvcbpf1a)'
                    },
                    disabled: {
                        background: 'var(--designSystem-button-variants-light-disabled-background__kvcbpf1b)',
                        text: 'var(--designSystem-button-variants-light-disabled-text__kvcbpf1c)'
                    }
                },
                outline: {
                    normal: {
                        background: 'var(--designSystem-button-variants-outline-normal-background__kvcbpf1d)',
                        text: 'var(--designSystem-button-variants-outline-normal-text__kvcbpf1e)',
                        border: 'var(--designSystem-button-variants-outline-normal-border__kvcbpf1f)'
                    },
                    hover: {
                        background: 'var(--designSystem-button-variants-outline-hover-background__kvcbpf1g)',
                        text: 'var(--designSystem-button-variants-outline-hover-text__kvcbpf1h)',
                        border: 'var(--designSystem-button-variants-outline-hover-border__kvcbpf1i)'
                    },
                    pressed: {
                        background: 'var(--designSystem-button-variants-outline-pressed-background__kvcbpf1j)',
                        text: 'var(--designSystem-button-variants-outline-pressed-text__kvcbpf1k)',
                        border: 'var(--designSystem-button-variants-outline-pressed-border__kvcbpf1l)'
                    },
                    disabled: {
                        background: 'var(--designSystem-button-variants-outline-disabled-background__kvcbpf1m)',
                        text: 'var(--designSystem-button-variants-outline-disabled-text__kvcbpf1n)',
                        border: 'var(--designSystem-button-variants-outline-disabled-border__kvcbpf1o)'
                    }
                }
            }
        },
        text: {
            primary: 'var(--designSystem-text-primary__kvcbpf1p)',
            secondary: 'var(--designSystem-text-secondary__kvcbpf1q)'
        }
    },
    __storybook: {
        background: 'var(--__storybook-background__kvcbpf1r)'
    }
};
export { NbButton, NbIcon, NbLinkButton, NbText, TypographyStyles, darkColors, darkThemeClass, lightColors, lightThemeClass, scrollbarClass, theme };
